// Import SVG icons
import beachIcon from "~/assets/share/icon/beach.svg";
import bikeIcon from "~/assets/share/icon/bike.svg";
import culinaryIcon from "~/assets/share/icon/culinary.svg";
import cultureIcon from "~/assets/share/icon/culture.svg";
import diveIcon from "~/assets/share/icon/dive.svg";
import fishIcon from "~/assets/share/icon/fish.svg";
import golfIcon from "~/assets/share/icon/golf.svg";
import hikeIcon from "~/assets/share/icon/hike.svg";
import musicIcon from "~/assets/share/icon/music.svg";
import paddleIcon from "~/assets/share/icon/paddle.svg";
import safariIcon from "~/assets/share/icon/safari.svg";
import skiIcon from "~/assets/share/icon/ski.svg";
import spaIcon from "~/assets/share/icon/spa.svg";
import surfIcon from "~/assets/share/icon/surf.svg";

// Icon mapping based on the data
export const iconMap = {
  // Direct matches with available SVGs
  beach: beachIcon,
  bike: bikeIcon,
  culinary: culinaryIcon,
  culture: cultureIcon,
  dive: diveIcon,
  fish: fishIcon,
  golf: golfIcon,
  hike: hikeIcon,
  hiking: hikeIcon, // alias for hike
  music: musicIcon,
  paddle: paddleIcon,
  safari: safariIcon,
  ski: skiIcon,
  spa: spaIcon,
  surf: surfIcon,

  // Aliases used in destination data
  mountain: skiIcon, // for ski activities
  snow: skiIcon, // for snowboard activities
  water: surfIcon, // for surf/snorkel activities
  sun: beachIcon, // for beach activities
  wine: culinaryIcon, // for wine activities
  dining: culinaryIcon, // for culinary activities
  wellness: spaIcon, // for spa activities
  city: cultureIcon, // for city activities
  historic: cultureIcon, // for history activities
  nature: safariIcon, // for wildlife activities
  adventure: hikeIcon, // for adventure activities
  tree: hikeIcon, // for national park activities (fallback to hiking)
};

/**
 * Get the appropriate icon for a given activity type
 * @param {string} iconType - The icon type/name
 * @returns {string|null} - The icon URL or null if not found
 */
export const getActivityIcon = (iconType) => {
  if (!iconType) return null;
  return iconMap[iconType.toLowerCase()] || null;
};

/**
 * Check if an icon exists for the given type
 * @param {string} iconType - The icon type/name
 * @returns {boolean} - Whether the icon exists
 */
export const hasActivityIcon = (iconType) => {
  if (!iconType) return false;
  return Boolean(iconMap[iconType.toLowerCase()]);
};